module.exports = __webpack_public_path__ + "img/Missing Stone.3d643a2b.png";